/* Create / rename / recolour a project, rename / recolour a tag. Deleting and
   archiving live on the scope page itself, next to what they affect. */
import React, { useState } from 'react';
import { type HueName, useStore } from '@habishine/client-core';

import { Dialog, inputClass, Label } from './Dialog';
import { HuePicker } from './HuePicker';
import { Button } from './ui';

export function ProjectEditor({ projectId, onClose }: { projectId: string | null; onClose: () => void }) {
  const { state, createProject, updateProject, nextProjectHue } = useStore();
  const existing = projectId ? state.projects.find((p) => p.id === projectId) : null;
  const [name, setName] = useState(existing?.name ?? '');
  const [hue, setHue] = useState<HueName>(existing?.hue ?? nextProjectHue());
  const save = (e: React.FormEvent) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    if (existing) updateProject(existing.id, { name: n, hue });
    else createProject(n, hue);
    onClose();
  };
  return (
    <Dialog title={existing ? 'Edit project' : 'New project'} onClose={onClose}
      footer={<><Button type="button" variant="ghost" onClick={onClose}>Cancel</Button><Button type="submit" form="project-editor" variant="primary" disabled={!name.trim()}>{existing ? 'Save' : 'Create'}</Button></>}>
      <form id="project-editor" onSubmit={save} className="space-y-3">
        <label className="block"><Label>NAME</Label><input className={inputClass} value={name} onChange={(e) => setName(e.target.value)} placeholder="House move" autoFocus /></label>
        <div><Label>COLOUR</Label><HuePicker value={hue} onChange={setHue} /></div>
      </form>
    </Dialog>
  );
}

export function TagEditor({ tagId, onClose }: { tagId: string; onClose: () => void }) {
  const { state, updateTag } = useStore();
  const existing = state.tags.find((t) => t.id === tagId);
  const [name, setName] = useState(existing?.name ?? '');
  const [hue, setHue] = useState<HueName>(existing?.hue ?? 'teal');
  if (!existing) return null;
  const save = (e: React.FormEvent) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    updateTag(existing.id, { name: n, hue });
    onClose();
  };
  return (
    <Dialog title="Edit tag" onClose={onClose}
      footer={<><Button type="button" variant="ghost" onClick={onClose}>Cancel</Button><Button type="submit" form="tag-editor" variant="primary" disabled={!name.trim()}>Save</Button></>}>
      <form id="tag-editor" onSubmit={save} className="space-y-3">
        <label className="block"><Label>NAME</Label><input className={inputClass} value={name} onChange={(e) => setName(e.target.value)} autoFocus /></label>
        <div><Label>COLOUR</Label><HuePicker value={hue} onChange={setHue} /></div>
      </form>
    </Dialog>
  );
}
